if (!customElements.get('sticky-buy-button')) {
    class StickyBuyButton extends HTMLElement {
        constructor() {
          super();
          this.parent = this.closest('.atc-mobile-sticky') ?? "";
        }
    
        connectedCallback() {
            if (!this) return;
    
            const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        this.classList.remove("fixed");
                    } else {
                        this.classList.add("fixed");
                    }
                });
            },
            {
                rootMargin: "0px 0px 0px 0px",
                threshold: 0
            }
            );

            observer.observe(this.parent);
        }
    }
      
    customElements.define('sticky-buy-button', StickyBuyButton);    
}